export default {
  carBrand: [],
  carModel: [],

  province: [],
  city: [],

  services: [],

  customerBanners: [],

  blogHome: [],

  socials: [],

  products: [],
  productsListPage: [],

  category: [],

  ringFeature: [],
  wideFeature: [],
  ratioFeature: [],

  productDetail: [],

  similarProducts: [],

  tabOneProducts: [],
  tabTwoProducts: [],
  tabThreeProducts: [],

  dynamicPageContent: [],

  ticketCategory: [],

  blogs: [],
  blog: [],
  relatedBlogs: [],

  service: {},

  faq: [],

  comments: [],

  newsLetters: [],

  slides: [],
  team: [],
  poster1: {},
  poster2: {},
  posterProducts: {},
  posterBlogs: {},

  rules: {},
  contactUs: {},
  faqPage: {},
  aboutUs: {},

  brands: [],
};
